export default __webpack_public_path__ + "static/media/explore12.f871d414.png";